import {NodeType} from "../../../../model/ModelData";

export const editMenuItems = {
  [NodeType.START]: ["greet", "settings", "static", "dynamic"],
  [NodeType.TEXT]: ["greet", "settings", "llm_boost", "static"],
  [NodeType.TEACHING]: ["greet", "settings", "output_parser", "static"],
  [NodeType.QUERY]: ["greet", "settings", "llm_boost", "static", "dynamic"],
  [NodeType.QA]: ["greet", "settings_booster", "slots", "static", "dynamic"],
  [NodeType.RECOMMENDATION]: ["greet", "settings", "filter", "llm_boost", "output_parser", "slots", "static"],
  [NodeType.GEN_AI_WORKFLOW]: ["greet", "settings_booster", "input_args", "output_parser", "static", "dynamic"],
  [NodeType.CHATBOT]: ["greet", "settings_booster", "input_args", "output_parser", "static", "dynamic"],
  [NodeType.AGENT]: ["greet", "settings_booster", "input_args", "output_parser", "static", "dynamic"],
  [NodeType.HOOK]: ["greet", "settings", "output_parser", "static", "dynamic"],
  [NodeType.CALL_TRANSFER]: ["greet", "settings"],
  [NodeType.INPUT]: ["greet", "settings", "llm_boost", "static", "dynamic"],
  [NodeType.CHOICE]: ["greet", "settings", "llm_boost", "static", "dynamic"],
  [NodeType.SWITCH]: ["greet", "settings", "static", "dynamic"],
  [NodeType.START_FORM]: ["greet", "settings", "static"],
  [NodeType.END_FORM]: ["greet", "settings", "static"],
  [NodeType.START_FLOW]: ["greet", "settings", "static", "input_params", "output_params", "dynamic"],
  [NodeType.SET_VAR]: ["vars", "static"],
  [NodeType.END]: ["greet"],
  [NodeType.JAVASCRIPT]: ["output_parser", "settings", "static"],
}

export const menuItemsInfo = {
  greet: {primary: "Greet messages", secondary: "Enter messages agent can send to the user"},
  please_wait_messages: {primary: "Please wait messages", secondary: "Enter messages agent can send to the user"},
  slots: {primary: "Slots", secondary: "Add slots"},
  settings: {primary: "Settings", secondary: "Add additional data to your node"},
  settings_booster: {primary: "Settings", secondary: "A powerful AI technology capable of understanding and generating human-like text."},
  settings_tools: {primary: "Use Tools", secondary: "A powerful AI technology capable of understanding and calling function."},
  filter: {primary: "Filter", secondary: "Create an SQL query to filter data within the results."},
  static: {primary: "Static routes", secondary: "Route your agent on other node with: next, no-match or fail"},
  dynamic: {primary: "Dynamic routes", secondary: "Route your agent on other node by catching some intent"},
  knowledge_base: {primary: "Knowledge base", secondary: "Enter knowledge base parameters"},
  vars: {primary: "Set variables", secondary: "Set global, flow or form variables"},
  output_parser: {primary: "Output parser", hook: "API Output parser", secondary: "Create your parser with Javascript code"},
  input_params: {primary: "Input Params", hook: "Input params from this flow to the selected flow", secondary: "Set params for next flow"},
  output_params: {primary: "Output Params", hook: "Output params from the flow selected to this flow", secondary: "Set params from selected flow to this flow"},
  llm_boost: {primary: "LLM Booster", secondary: "A powerful AI technology capable of understanding and generating human-like text."},
  input_args: {primary: "Input Args", secondary: "Define input arguments and parameters that the GenAI workflow node will receive and process during execution"},
}